import { createSelector } from 'reselect'
import { selectCurrentConversation } from 'ducks/tickets/selectors/selectCurrentConversation'

export const selectCurrentTicketMailboxId = createSelector(
  selectCurrentConversation,
  ticket => (ticket ? ticket.channel : null)
)
